export enum eSignatureVendor {
  none = 0,
  adobe = 1,
  docu = 2,
  ti = 3,
  msb = 4,
}
